import './validate/validate.directive';

import './inner-html/inner-html.directive';

import './breadcrumbs/breadcrumbs.directive';

import './cpf-cnpj-validate-mask/cpf-cnpj-validate-mask.directive';

import './mask/mask.directive';

import './check-all/check-all.directive';

import './air-datepicker/air-datepicker.directive';

import './infinite-scroll-page/infinite-scroll-page.directive';

import './qr-code/qr-code.directive';
